import * as messageActions from './message.actions';
import {messageReducer} from './message.reducer';

const makeMessages = (messages, type) => {
    return messages.map(message => {
      return { sticky: true, severity: type, detail: message };
    });
  };

  export {messageActions, messageReducer, makeMessages}